module.exports = __webpack_public_path__ + "static/xiaohongshu-51d9132fd9f0eea67eeccbdec1b4f038.png";